var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useTreeApi } from "../context";
import { Cursor } from "./cursor";
export const ListOuterElement = forwardRef(function Outer(props, ref) {
    const { children } = props, rest = __rest(props, ["children"]);
    const tree = useTreeApi();
    return (_jsxs("div", Object.assign({ 
        // @ts-ignore
        ref: ref }, rest, { onClick: (e) => {
            if (e.currentTarget === e.target)
                tree.deselectAll();
        }, children: [_jsx(DropContainer, {}), children] })));
});
const DropContainer = () => {
    const tree = useTreeApi();
    return (_jsx("div", { style: {
            height: tree.visibleNodes.length * tree.rowHeight,
            width: "100%",
            position: "absolute",
            left: "0",
            right: "0",
        }, children: _jsx(Cursor, {}) }));
};
